// -----------------------------
// Prestige Theme: MwSt.-Anzeige
// -----------------------------
document.addEventListener('DOMContentLoaded', function () {

  function appendTaxInfo() {
    const priceElements = document.querySelectorAll('.price-list .sale-price, .price-list .compare-at-price');
    priceElements.forEach(el => {
      if (!el.querySelector('.tax-info')) {
        const span = document.createElement('span');
        span.className = 'tax-info';
        span.textContent = ' inkl. MwSt.';
        el.appendChild(span);
      }
    });
  }

  // Initial aufrufen
  appendTaxInfo();

  // Dynamische Variantenwechsel
  document.addEventListener('variant:change', appendTaxInfo);
  document.addEventListener('shopify:variant:change', appendTaxInfo);

});